import {
	apiTagsToSummaries,
	type ResourceTagSummary,
} from "kontrolEdge/components/Shared/NameTagEdit/useResourceTags";
import { isTagsManagerEnabled } from "@shared/config/featureFlags";

/**
 * Map the pivot-backed `tags` array from a KE list API row into
 * {@link ResourceTagSummary} objects for table rendering and filters.
 * Legacy `tag` (singular) is intentionally ignored — it is being removed
 * from the backend.
 */
export function mapKeListResourceTags(apiRow: {
	tags?: unknown;
}): ResourceTagSummary[] | undefined {
	const richTags = isTagsManagerEnabled()
		? apiTagsToSummaries(apiRow.tags)
		: [];
	return richTags.length > 0 ? richTags : undefined;
}

/** Free-text filter haystack from rich tag names only. */
export function keListTagFilterHaystack(row: {
	tagsRich?: ResourceTagSummary[];
}): string {
	if (!Array.isArray(row.tagsRich)) return "";
	return row.tagsRich.map((t) => t.name).filter(Boolean).join(" ");
}
